import {rem} from 'polished';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {media, spacing} from '../../theme';
import colors from '../../theme/variables/colors';
import SmileIcon from '../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-smile.svg'
import {FormSectionElements, ProgramContainer} from '../../entities/formTemplateDataType';
import {FeedbackStatus} from '../../entities/Constants';
import {setParam} from '../../utilities/URLUtils';
import Utils from "../../utilities/Utils";

export const FeedbackContainer = styled.div<{ lang: string; $hasHyperlink?: boolean }>`
    max-width: ${props => props.lang === 'en'
            ? (props?.$hasHyperlink
                    ? rem(540)
                    : rem(650))
            : (props?.$hasHyperlink ? rem(850) : rem(910))};
    width: 100%;
    display: flex;
    background-color: ${colors.palette.greyscale5};
    align-items: center;
    padding: ${spacing.spacing5};
    margin-top: ${spacing.spacing5};
    margin-bottom: ${spacing.spacing7};
        //border: 1px solid ${colors.palette.greyscale20};
    gap: ${spacing.spacing4};
    @media (max-width: 768px) {
        align-items: center;
    }

    svg {
        margin-right: ${spacing.spacing4};
        width: 64px;

        @media ${media.small} {
            width: 45px;
        }
    }


    @media (max-width: ${props => props.lang === 'en' ? 768 : 950}px ) {
        max-width: ${props => props.lang === 'en' ? rem(360) : rem(550)};
    }
`;

const FeedbackContent = styled.div<{ $isHyperlink?: boolean }>`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    //justify-content: center;
    ${props => (props.$isHyperlink ? "" : "justify-content: space-between;")}
    gap: ${props => (props.$isHyperlink ? spacing.spacing4 : spacing.spacing4)};
`;
const FeedbackButton = styled.div`
    width: 100%;
    max-width: ${props => props.lang === 'en' ? '250px' : '350px'};
    height: 48px;
    border-radius: 4px;
    border: 2px solid #0066CC;
    background-color: #FFFFFF;
    color: #0066CC;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0 0.5rem;
`;

const SmileImage = styled.img`
    width: 27px;
    height: 27px;
    flex-shrink: 0;
`;

export default function FeedbackComponent({
                                              programContainer,
                                              isEng,
                                              field,
                                              status,
                                              code,
                                              transactionId,
                                              applicationType,
                                              isHyperlink = false,
                                              params,
                                              feedbackTitle,
                                              feedbackLinkText
                                          }: {
    programContainer?: ProgramContainer;
    field?: FormSectionElements;
    isEng?: boolean;
    status?: string;
    code?: string;
    transactionId?: string;
    applicationType?: string;
    isHyperlink?: boolean;
    params?: Record<string, string>;
    feedbackTitle?: string;
    feedbackLinkText?: string;
}) {

    const hasFeedbackLink = field?.feedbackLinkIsHyperlink || isHyperlink;

    const [feedbackUrl, setFeedbackUrl] = useState<string>('');
    let url = '';
    useEffect(() => {

        const sts = status || field?.feedback?.status || FeedbackStatus.Success;
        const cd = code || field?.feedback?.code || FeedbackStatus.Failed;


        if (programContainer.Profile?.email) {
            url = isEng ? (field?.FeedbackURL_CXP || programContainer?.FeedbackURL_CXP) : (field?.FeedbackURLFRA_CXP || programContainer?.FeedbackURLFRA_CXP);
        }
        if (!url) {
            url = isEng ? (field?.FeedbackURL || programContainer?.FeedbackURL) : (field?.FeedbackURLFRA || programContainer?.FeedbackURLFRA);
        }

        if(programContainer.useFeedbackUrlOnly){
            url= isEng ? programContainer?.FeedbackURL : programContainer?.FeedbackURLFRA;
        }

        if (url) {
            url = `${url.split('?')[0]}?`
            url = setParam(url, 'cxpuser', `${programContainer.Profile?.email ? 'yes' : 'no'}`);
            url = setParam(url, 'sts', sts);
            if (field?.feedback?.status !== FeedbackStatus.Success) {  // Only pass code if it's a non-successful feedback.
                url = setParam(url, 'code', cd);
            }
            url = setParam(url, 'tid', transactionId);
            url = setParam(url, "svc", applicationType?.trim())

            url = setParam(url, 'src', hasFeedbackLink ? 'link' : 'button');
            url = setParam(url, 'sglocale', isEng ? 'en' : 'fr-ca');
        }
        const urlParams: Record<string, string> = params || field?.findFieldByName('surveyUrlParams')?.Value
        if (url && urlParams && Object.keys(urlParams)?.length > 0) {
            url = Object.entries(urlParams)?.reduce((acc, [key, value]) => {
                if (Utils.isNotNullOrEmpty(value)) {
                    return setParam(acc, key, value);
                }
                return acc;
            }, url);
        }

        setFeedbackUrl(url);
    }, [field, isEng, programContainer?.Profile]);

    return (
        <FeedbackContainer lang={isEng ? 'en' : 'fr'} $hasHyperlink={field?.feedbackLinkIsHyperlink || isHyperlink}>
            <SmileImage src={SmileIcon} alt="Smile Icon"/>
            <FeedbackContent $isHyperlink={hasFeedbackLink}>
                <div style={{whiteSpace: 'normal'}}>
                    {feedbackTitle || (isEng ? "How was your experience today?" : "Comment s’est déroulée votre expérience aujourd’hui?")}
                    {hasFeedbackLink && (
                        <>
                            {' '}
                            <a
                                href={feedbackUrl || undefined}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    if (!feedbackUrl) e.preventDefault();
                                }}
                            >
                                {feedbackLinkText || (isEng ? "Share your feedback." : "Faites-nous part de vos commentaires.")}
                            </a>
                        </>
                    )}
                </div>
                {!hasFeedbackLink &&
                    (
                        <FeedbackButton
                            lang={isEng ? 'en' : 'fr'}
                            onClick={() => window.open(feedbackUrl, '_blank', 'noopener,noreferrer')}
                        >
                            {isEng ? "Share your feedback" : "Faites-nous part de vos commentaires"}
                        </FeedbackButton>
                    )
                }
            </FeedbackContent>
        </FeedbackContainer>
    );
}
